// EditTestDialog.jsx - Test düzenleme dialog'u
import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  CircularProgress,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { updateTest } from '../../redux/testSlice';

const EditTestDialog = ({ open, onClose, test, testId, loading }) => {
  const dispatch = useDispatch();
  
  const [editTest, setEditTest] = useState({
    name: "",
    description: "",
    type: "",
    instructions: "",
    imageUrl: ""
  });

  const testTypes = [
    { value: "SURVEY", label: "Survey" },
    { value: "DEPRESSION", label: "Depression" },
    { value: "ANXIETY", label: "Anxiety" },
    { value: "EMOTIONAL_INTELLIGENCE", label: "Emotional Intelligence" },
    { value: "EMPATHY", label: "Empathy" },
    { value: "MENTAL_WELLBEING", label: "Mental Wellbeing" },
    { value: "SOCIAL_PHOBIA", label: "Social Phobia" },
    { value: "WHITE_BEAR_SUPPRESSION", label: "White Bear Suppression" },
    { value: "EATING_BEHAVIOR", label: "Eating Behavior" }
  ];

  useEffect(() => {
    if (test) {
      setEditTest({
        name: test.name || "",
        description: test.description || "",
        type: test.type || "",
        instructions: test.instructions || "",
        imageUrl: test.imageUrl || ""
      });
    }
  }, [test]);

  const handleSubmit = () => {
    if (!editTest.name || !editTest.description || !editTest.type || !editTest.instructions) {
      toast.error("Please fill in all required fields!");
      return;
    }
    
    dispatch(updateTest({
      testId: testId,
      testData: editTest
    }));
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Edit Test</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Test Name *"
            value={editTest.name}
            onChange={(e) => setEditTest({...editTest, name: e.target.value})}
          />
          <TextField
            fullWidth
            label="Description *"
            multiline
            rows={3}
            value={editTest.description}
            onChange={(e) => setEditTest({...editTest, description: e.target.value})}
          />
          <FormControl fullWidth>
            <InputLabel>Test Type *</InputLabel>
            <Select
              value={editTest.type}
              label="Test Type *"
              onChange={(e) => setEditTest({...editTest, type: e.target.value})}
            >
              {testTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label="Instructions *"
            multiline
            rows={4}
            value={editTest.instructions}
            onChange={(e) => setEditTest({...editTest, instructions: e.target.value})}
          />
          <TextField
            fullWidth
            label="Image URL"
            value={editTest.imageUrl}
            onChange={(e) => setEditTest({...editTest, imageUrl: e.target.value})}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditTestDialog;